var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 249.808594 202.566406 L 233.089844 67.46875 C 232.972656 66.542969 232.53125 65.714844 231.808594 65.128906 C 227.292969 61.453125 208.28125 48.949219 160.917969 51.457031 C 121.011719 53.570313 102.945313 68.871094 98.308594 73.554688 C 97.5 74.371094 97.164063 75.519531 97.351563 76.652344 L 115.371094 184.503906 L 115.398438 184.535156 C 105.105469 181.078125 91.6875 181.925781 78.808594 187.847656 C 57.066406 197.84375 45.164063 218.40625 52.230469 233.773438 C 59.292969 249.140625 82.648438 253.496094 104.394531 243.5 C 123.0625 234.917969 134.433594 218.550781 132.816406 204.363281 L 133.007813 204.585938 L 117.589844 118.246094 C 117.589844 118.246094 130.292969 104.890625 168.738281 101.632813 C 207.183594 98.375 221.519531 104.890625 221.519531 104.890625 L 231.394531 182.226563 L 231.414063 182.25 C 221.234375 179.097656 208.160156 180.058594 195.605469 185.828125 C 173.863281 195.824219 161.964844 216.386719 169.03125 231.753906 C 176.09375 247.121094 199.449219 251.476563 221.191406 241.480469 C 239.859375 232.898438 251.230469 216.539063 249.617188 202.355469 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNotes);
export default __webpack_public_path__ + "static/media/MusicNotes.ea2ba1abfa4b1e51ccfaaa2ad06b55c1.svg";
export { ForwardRef as ReactComponent };